import React, { useEffect, useRef, useState } from "react";
import { postDetails } from "../../services/http/http.service";
import { showLoader, hideLoader } from "../../store/Loader/loader.slice";
import APIList from "../../utils/constants/APIList";
import { useAppDispatch } from "../../store/storeRequests";
import PageHeader from "../../components/PageHeader/PageHeader";
import CommonTable, { TableColumn } from "../../components/Table/CommonTable";
import { PlusCircleFill, Trash3Fill } from "react-bootstrap-icons";
import { Modal, Form, Button } from "react-bootstrap";
import CustomDatePicker from "../../components/CustomDatePicker/CustomDatePicker";
import { hideToast, showToast } from "../../store/Toast/toast.slice";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaCalendarAlt } from "react-icons/fa";
import { format } from "date-fns";
import { customSingleSelectStyles, customStyles } from "../../utils/constants/CustomStyles.constants";
import formatDate from "../../utils/helpers/formatDate";

interface Notification {
  id: number;
  content: string;
  display_time: string;
  sendTo: string | string[];
}

interface Attendee {
  id: number;
  name: string;
}

interface Group {
  id: number;
  name: string;
  status: number;
}

const NotificationData = () => {
  const cmpMounted = useRef(false);
  const dispatch = useAppDispatch();
  const [data, setData] = useState<Notification[]>([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [attendees, setAttendees] = useState<Attendee[]>([]);
  const [groups, setGroups] = useState<Group[]>([]);
  const [selectedAttendees, setSelectedAttendees] = useState<number[]>([]);
  const [selectedGroups, setSelectedGroups] = useState<number[]>([]);
  const [selectedOption, setSelectedOption] = useState<string>("attendee");
  const [content, setContent] = useState("");
  const [date, setDate] = useState<Date | null>(null);
  const [sendTo, setSentTo] = useState<string[] | string>([""]);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState<Set<number>>(new Set());
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  // const [errorMessage, setErrorMessage] = useState();
  const [errors, setErrors] = useState({
    date: "",
    content: "",
    attendees: "",
    groups: "",
  });
  const [currentNotification, setCurrentNotification] =
    useState<Notification | null>(null);
    const [totalRecords, setTotalRecords] = useState(0);

  const handleIconClick = () => {
    setIsOpen(!isOpen);
  };

  const handleDateChange = (date: Date | null) => {
    if(!date) return;
    
    const now = new Date();

    // Check if selected date is earlier than today
    if (date < now) {
      dispatch(showToast(`Close date and time cannot be earlier than today`));
      setTimeout(() => dispatch(hideToast()), 3000);
      return;
    }
    setDate(date);
    setIsOpen(false);
  };

  useEffect(() => {
    if (cmpMounted.current === true) return;
    cmpMounted.current = true;
    fetchNotificationData();
    // fetchAttendees();
    // fetchGroups();
  }, []);

  const fetchNotificationData = async (page:any = 1) => {
    try {
      dispatch(showLoader("Loading Data..."));
      const payload = {
        pageNumber: page,
        pageSize: 10
      }
      const response = await postDetails(APIList.GET_ALL_NOTIFICATION, payload);
      const modifiedData = response.data.data.map((item: Notification) => ({
        ...item,
        // display_time: formatDate(item.display_time, "year-month-time"),
        date: new Date(item.display_time).toLocaleString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        }),
      }));

      // console.log("MODIFIED DATA", modifiedData)
      setData(modifiedData|| []);
      // setData(response.data?.data|| []);
      setTotalRecords(response.data.totalcount)
      console.log(response.data);
    } catch (error) {
      dispatch(showToast("Some error occurred while fetching data"));
      setTimeout(() => dispatch(hideToast()), 3000);
      console.error("Error fetching data:", error);
    } finally {
      dispatch(hideLoader());
    }
  };

  const handlePageChange = (page: number) => {
    // console.log("PAGE",page)
    fetchNotificationData(page+1);
  };

  const fetchAttendees = async () => {
    try {
      dispatch(showLoader("Loading Data..."));
      const peopleData = await postDetails(APIList.GET_ALL_PEOPLE, {});
      const groupData = await postDetails(APIList.GET_ALL_GROUP, {});
      const activeGroups = groupData.data.filter(
        (item: Group) => item.status === 1
      );
      setGroups(activeGroups);
      setAttendees(peopleData.data);
      // console.log(response.data);
    } catch (error) {
      dispatch(showToast("Some error occurred while fetching attendee and group data"));
      setTimeout(() => dispatch(hideToast()), 3000);
      console.error("Error fetching attendee and group data:", error);
    }finally{
      dispatch(hideLoader());
    }
  };

  // const fetchGroups = async () => {
  //   try {
  //     dispatch(showLoader("Loading Groups..."));
  //     const response = await postDetails(APIList.GET_ALL_GROUP, {});
  //     const activeGroups = response.data.filter(
  //       (item: Group) => item.status === 1
  //     );
  //     setGroups(activeGroups);
  //     // console.log(response.data);
  //   } catch (error) {
  //     dispatch(showToast("Some error occurred while fetching groups"));
  //     setTimeout(() => dispatch(hideToast()), 3000);
  //     console.error("Error fetching groups:", error);
  //   }finally{
  //     dispatch(hideLoader());
  //   }
  // };

  const handleShowAddModal = () => {
    // dispatch(showLoader("Loading Data..."));
    fetchAttendees();
    // fetchGroups();
    setShowAddModal(true);
    setSelectedAttendees([]);
    setSelectedGroups([]);
    setSelectedOption("attendee");
    setContent("");
    setDate(null);
    // dispatch(hideLoader());
  };

  const handleCloseAddModal = () => {
    setErrors({
      date: "",
      content: "",
      attendees: "",
      groups: "",
    });
    setShowAddModal(false);
  }
  const handleCloseDeleteModal = () => setShowDeleteModal(false);

  const handleShowEditModal = (notification: Notification) => {
    setCurrentNotification(notification);
    setContent(notification.content);
    setDate(
      notification.display_time ? new Date(notification.display_time) : null
    );
    setSentTo(notification.sendTo);
    setShowEditModal(true);
  };


  const handleCloseEditModal = () => setShowEditModal(false);

  const handleSubmitAdd = async () => {
    let formErrors = {date: "",
      content: "",
      attendees: "",
      groups: "",};
  //   if (
  //     !date ||
  //     !content ||
  //     (selectedOption === "attendee" && selectedAttendees.length === 0) ||
  //     (selectedOption === "group" && selectedGroups.length === 0)
  //   ) {
  //     // setErrorMessage("Please fill in all fields.");
  //     dispatch(showToast("Please fill in all fields."));
  //     setTimeout(() => dispatch(hideToast()), 3000);
  //     return;
  //   }

  if (!date) {
    formErrors.date = "Date is required.";
  }

  if (!content) {
    formErrors.content = "Content is required.";
  }

  // if (selectedOption === "attendee" && selectedAttendees.length === 0) {
  //   formErrors.attendees = "Please select at least one attendee.";
  // }

  // if (selectedOption === "group" && selectedGroups.length === 0) {
  //   formErrors.groups = "Please select at least one group.";
  // }

  if (selectedOption === "attendee" && selectedAttendees.length === 0) {
    formErrors.attendees = "Please select at least one attendee.";
  } else if (selectedOption === "group" && selectedGroups.length === 0) {
    formErrors.groups = "Please select at least one group.";
  }

  // if (Object.keys(formErrors).length > 0) {
  //   setErrors(formErrors);
  //   dispatch(showToast("Please fill in all fields."));
  //   setTimeout(() => dispatch(hideToast()), 3000);
  //   return;
  // }

  if (formErrors.date || formErrors.content || formErrors.attendees || formErrors.groups) {
    setErrors(formErrors);
    dispatch(showToast("Please fill in all required fields."));
    setTimeout(() => dispatch(hideToast()), 3000);
    return;
  }

  // Clear errors if form is valid
  setErrors({
    date: "",
    content: "",
    attendees: "",
    groups: "",
  });

    // setErrorMessage(null);

    const Ids =
      selectedOption === "attendee" ? selectedAttendees : selectedGroups;
    const sent_to_all = selectedOption === "all" ? 1 : 0;
    const send_to_group = selectedOption === "group" ? 1 : 0;

    const display_time = date ? date.toISOString() : "";

    const payload = {
      type: "notification",
      Ids,
      sent_to_all,
      send_to_group,
      display_time,
      content,
    };

    try {
      const response = await postDetails(APIList.ADD_NOTIFICATION, payload);
      if (response.statusCode === 200) {
        dispatch(showToast("Notification Added Successfully."));
      } else {
        dispatch(showToast(`Failed To Add: ${response.message}`));
      }
    } catch (error) {
      console.error("Error sending notification:", error);
    } finally {
      setTimeout(() => dispatch(hideToast()), 3000);
      handleCloseAddModal();
      fetchNotificationData();
    }
  };

  const handleSubmitEdit = async () => {
    if (content === currentNotification?.content) {
      dispatch(showToast("No changes Done."));
      setTimeout(() => dispatch(hideToast()), 3000);
      return;
    }

    handleCloseEditModal();

    const payload = {
      id: currentNotification?.id,
      content,
    };

    try {
      const response = await postDetails(APIList.EDIT_NOTIFICATION, payload);
      console.log(response);
      if (response.statusCode === 200) {
        dispatch(showToast("Notification Updated Successfully."));
      } else {
        dispatch(showToast(`Failed To Update: ${response.message}`));
      }
    } catch (error) {
      console.error("Error updating notification:", error);
    } finally {
      setTimeout(() => dispatch(hideToast()), 3000);
      fetchNotificationData();
    }
  };

  const deleteItemById = async (item: Notification) => {
    try {
      const response = await postDetails(APIList.DELETE_NOTIFICATION, {
        id: item.id,
      });

      if (response.status === "Failed") {
        console.log("Cannot delete notification");
        return;
      }

      setData((prevData) => prevData.filter((row) => row.id !== item.id));
      console.log("Notification deleted");
      dispatch(showToast("Notification Deleted Successfully."));
      setTimeout(() => dispatch(hideToast()), 3000);
    } catch (error) {
      console.error("Error deleting notification:", error);
    }
  };

  const handleBulkDelete = async () => {
    try {
      for (const id of selectedItems) {
        const itemToDelete = data.find((item) => item.id === id);
        if (itemToDelete) {
          await deleteItemById(itemToDelete);
        }
      }
      setSelectedItems(new Set());
      setShowDeleteModal(false);
    } catch (error) {
      console.error("Error deleting items:", error);
    }
  };

  const handleCheckboxChange = (selectedIds: Set<number>) => {
    // console.log(selectedIds);
    setSelectedItems(selectedIds);
  };

  const columns: TableColumn[] = [
    {
      key: "date",
      label: "Date",
      dataType: "string",
      sortable: true,
    },
    { key: "content", label: "Content", sortable: true, dataType: "string" },
    { key: "sendTo", label: "Sent To", dataType: "string" },
  ];

  const buttons = [
    {
      label: "Delete",
      theme: "danger",
      icon: <Trash3Fill />,
      onClick: () => setShowDeleteModal(true),
      disabled: selectedItems.size === 0,
    },
    {
      label: "Add Notification",
      theme: "warning",
      icon: <PlusCircleFill />,
      onClick: handleShowAddModal,
    },
  ];

  const attendeeOptions = attendees.map((attendee) => ({
    value: attendee.id,
    label: attendee.name,
  }));

  const groupOptions = groups.map((group) => ({
    value: group.id,
    label: group.name,
  }));

  return (
    <div>
      <PageHeader buttons={buttons} />
      <CommonTable<Notification>
        data={data}
        columns={columns}
        onEdit={handleShowEditModal}
        onDelete={deleteItemById}
        onCheckboxChange={handleCheckboxChange}
        pagination={true}
        rowsPerPage={10}
        actions={{
          view: false,
          edit: true,
          delete: true,
          checkbox: true,
          status: false,
          showModal: false,
        }}
        onPageChange={handlePageChange}
          apiPagination={true}
          totalPageCount={totalRecords}
      />

      {/* Add Notification Modal */}
      <Modal show={showAddModal} onHide={handleCloseAddModal}>
        <Modal.Header closeButton>
          <Modal.Title>Add Notification</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* {errorMessage && (
            <div className="alert alert-danger" role="alert">
              {errorMessage}
            </div>
          )} */}
          <div
           style={{
            maxHeight: "70vh",
            overflowY: "auto",
            padding: "1rem"
          }}
          >
          <Form>
            <Form.Group className="mb-3" controlId="formDate"
            style={{
              height: "95px"
            }}
            >
              <Form.Label className="font-14">Select Date & Time <span className="text-danger">*</span></Form.Label>
              <div className="date-picker-container">
                <DatePicker
                  selected={date}
                  onChange={handleDateChange}
                  showTimeSelect
                  timeFormat="HH:mm"
                  dateFormat="MMMM d, yyyy h:mm aa"
                  // className="form-control read-only-datepicker"
                  className={`mf-admin-inputfield`}
                  placeholderText="Select Date"
                  minDate={new Date()}
                  minTime={
                    date && date.toDateString() === new Date().toDateString()
                      ? new Date()
                      : new Date(new Date().setHours(0, 0, 0, 0))
                  }
                  maxTime={new Date(new Date().setHours(23, 59, 59))}
                  onFocus={(e) => e.preventDefault()}
                  timeIntervals={5}
                  // readOnly
                  onKeyDown={(e:any)=> {e.preventDefault()}}
                  // open={isOpen}
                  onClickOutside={() => setIsOpen(false)}
                />
                {/* <FaCalendarAlt
                  className="calendar-icon"
                  onClick={handleIconClick}
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                  }}
                /> */}
              </div>
              {errors.date && <div className="error-text font-12">{errors.date}</div> }
            </Form.Group>

            <Form.Group className="mb-3 font-14"
            style={{
              height: "95px"
            }}
            >
              <Form.Check
                type="radio"
                label="Select Attendee"
                name="selectOption"
                checked={selectedOption === "attendee"}
                onChange={() => setSelectedOption("attendee")}
                className="font-14"
              />
              <Select
                isMulti
                options={attendeeOptions}
                styles={customStyles}
                value={attendeeOptions.filter((option) =>
                  selectedAttendees.includes(option.value)
                )}
                onChange={(selectedOptions) => {
                  setSelectedAttendees(
                    selectedOptions.map((option) => option.value)
                  );
                }}
                isDisabled={selectedOption !== "attendee"}
              />
              {errors.attendees && <div className="error-text font-12 mt-1">{errors.attendees}</div> }
            </Form.Group>

            <Form.Group className="mb-3 font-14"
            style={{
              height: "95px"
            }}
            >
              <Form.Check
                type="radio"
                label="Select Group"
                name="selectOption"
                checked={selectedOption === "group"}
                onChange={() => setSelectedOption("group")}
                className="font-14"
              />
              <Select
                isMulti
                options={groupOptions}
                styles={customStyles}
                value={groupOptions.filter((option) =>
                  selectedGroups.includes(option.value)
                )}
                onChange={(selectedOptions) => {
                  setSelectedGroups(
                    selectedOptions.map((option) => option.value)
                  );
                }}
                isDisabled={selectedOption !== "group"}
              />
              {errors.groups && <div className="error-text font-12 mt-1">{errors.groups}</div> }
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Check
                type="radio"
                label="Send to All"
                name="selectOption"
                checked={selectedOption === "all"}
                onChange={() => setSelectedOption("all")}
                className="font-14"
              />
            </Form.Group>

            <Form.Group className="mb-3 font-14" controlId="formContent" >
              <Form.Label className="font-14">Content <span className="text-danger">*</span></Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={content}
                onChange={(e) => setContent(e.target.value)}
                maxLength={250}
                required={true}
                style={{
                  fontSize: "14px",
                  resize: "none",
                  height: "120px", 
                }}
              />
              {errors.content && <div className="error-text font-12 mt-1">{errors.content}</div> }
              <Form.Text className="text-muted">{content.length}/250</Form.Text>
            </Form.Group>
            
          </Form>
        <div className="d-flex align-items-center justify-content-end mt-4">
          <Button className="btn-danger" onClick={handleCloseAddModal}>
            Close
          </Button>
          <Button className="btn-warning text-white" onClick={handleSubmitAdd}>
            Send
          </Button>
          </div>
          </div>
        </Modal.Body>
        {/* <Modal.Footer> */}
        {/* </Modal.Footer> */}
      </Modal>

      {/* Edit Notification Modal */}
      <Modal show={showEditModal} onHide={handleCloseEditModal}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Notification</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="formDate">
            {/* <Form.Label className="font-14">Created Date</Form.Label> */}
              <CustomDatePicker
                label="Created Date"
                name="Created Date"
                required={true}
                dateFormat={"MMMM d, yyyy hh:mm"}
                onChange={setDate}
                disabled
                defaultDate={date}
              />
            </Form.Group>

            <Form.Group className="mb-3 font-14" controlId="formSentFrom">
              <Form.Label className="font-14">Sent From</Form.Label>
              <Form.Control as="select" value="Admin AsOne" disabled
               style={{
                fontSize: "14px"
              }}
              >
                <option  value="Admin AsOne"><span
                >Admin AsOne</span></option>
              </Form.Control>
            </Form.Group>

            <Form.Group className="mb-3 font-14" controlId="formSentTo">
              <Form.Label className="font-14">Sent To</Form.Label>
              <Form.Control as="select" value={sendTo} disabled
              style={{
                fontSize: "14px"
              }}
              >
                <option value={sendTo}
                
                >{sendTo}</option>
              </Form.Control>
            </Form.Group>

            <Form.Group className="mb-3 font-14" controlId="formContent">
              <Form.Label>Content</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={content}
                onChange={(e) => setContent(e.target.value)}
                maxLength={250}
                style={{
                  fontSize: "14px",
                  resize: "none",
                  height: "120px", 
                }}
              />
              <Form.Text className="text-muted">{content.length}/250</Form.Text>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn-danger" onClick={handleCloseEditModal}>
            Close
          </Button>
          <Button className="btn-warning text-white" onClick={handleSubmitEdit}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        centered
        className="deleteAll-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete?</p>
          <Button className="btn-danger" onClick={handleBulkDelete}>
            Delete
          </Button>
          <Button
            className="btn-warning text-white"
            onClick={handleCloseDeleteModal}
          >
            Cancel
          </Button>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default NotificationData;
